// @flow
import React from 'react';
import { SelectField } from '@src/formik-utils/FormFields';
import { COMMITTED_CAPACITY } from '@streaming-projects/user-commit-details/committed-capacity/enums';
import { useFormikContext } from 'formik';
import {
  getConfiguredMetricRowsFromFormikValues,
  getDimensionLevelConfigArrayFromMetricRow,
  getMetricsPath,
  getNewDimensionsRowWithDefaults,
  getUsedCommittedCapacityMetricsList,
} from '@streaming-projects/user-commit-details/committed-capacity/utils';

export const getMetricNameOptions = (rowValues, allConfiguredRows) => {
  const completeMetricsList = COMMITTED_CAPACITY.COMPLETE_METRICS_LIST;
  const chosenMetricName = rowValues.metricName;

  // Case 1: There is already a Metric Name which is selected. In this case, just return that single value for the UI to display it
  if (chosenMetricName) {
    const chosenMetricRow = completeMetricsList.find((x) => x.name === chosenMetricName);
    return [
      {
        name: chosenMetricRow.name,
        display_name: chosenMetricRow.label,
      },
    ];
  }

  // Case 2: When Metric Name is not selected, show all options and disable any used metrics
  const usedMetricsList = getUsedCommittedCapacityMetricsList(allConfiguredRows);
  return completeMetricsList.map((x) => ({
    name: x.name,
    display_name: x.label,
    shouldNotBeSelectable: usedMetricsList.includes(x.name),
  }));
};

export const SPCommittedCapacityMetricNameDropdownContainer = ({
  row,
  dimensionsArrayHelpers,
  index,
}) => {
  const { values: formikValues } = useFormikContext();
  const configuredMetrics = getConfiguredMetricRowsFromFormikValues(formikValues);

  const handleMetricChange = (event, value) => {
    // Check if there are no existing line items for this metric
    const currentMetricObj = configuredMetrics[index];
    const existingLineItems = getDimensionLevelConfigArrayFromMetricRow(currentMetricObj);

    // If no line items exist, automatically add the first one
    if (existingLineItems.length === 0 && value) {
      const newRow = getNewDimensionsRowWithDefaults(value);
      dimensionsArrayHelpers.push(newRow);
    }
  };

  const metricsPath = getMetricsPath(index);
  const metricNamePath = `${metricsPath}.metricName`;
  const isMetricValueSet = row.metricName != null;

  return (
    <SelectField
      addErrorMessage={false}
      addLabel={false}
      disableOnFormErrors={false}
      disabled={isMetricValueSet}
      fieldDisplayName="Select Metric"
      fieldName={metricNamePath}
      onChange={handleMetricChange}
      options={getMetricNameOptions(row, configuredMetrics)}
    />
  );
};
